// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormFolder } from '~/utils/interface/folder';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      name: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      isCurrentApply: yup.boolean().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormFolder = {
  name: EMPTY_STRING,
  isCurrentApply: true,
};
